import { desktopBreakpoint } from '../../../constants/breakpoints';

/**
 * The methodology behind this carousel is to copy the first and last items to the opposite
 * sides of the carousel as extra elements, and when the user lands on them, we send them
 * back to their real versions. This gives the illusion that the carousel is infinite.
 * 
 * The slide duplication is handled in the template.
 */
export default class {
  constructor(context) {
    this.context = context;

    this.wrapper = this.context.querySelector('.MarketingBanner_inner');
    this.prevButton = this.context.querySelector('[data-marketing-banner-prev]');
    this.nextButton = this.context.querySelector('[data-marketing-banner-next]');

    const slide = this.context.querySelector('.MarketingBanner_item');
    if (slide) {
      this.slideWidth = slide.clientWidth
    }

    this.currentSlide = 0;

    if (this.prevButton) {
      this.prevButton.toggleAttribute('disabled');
      this.prevButton.toggleAttribute('aria-disabled');
      this.prevButton.classList.add('MarketingBanner_action-disabled');
    };

    this.slideCount = parseInt(this.context.dataset.slideCount, 10);

    this.init();
  }

  init() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onPrevClick, { passive: true });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onNextClick, { passive: true });
    }

    window.addEventListener('resize', this.handleWindowResize, { passive: true });
  }

  handleWindowResize = () => {
    const slide = this.context.querySelector('.MarketingBanner_item');
    if (!slide) return;
    // If we resize on mobile, fix the translation amount
    this.slideWidth = slide.clientWidth;
    this.slideCarousel();

    // And if we're on the desktop view, stop translating the bar
    if (window.innerWidth > desktopBreakpoint && this.wrapper) {
      this.wrapper.style.transform = 'translateX(0)';
    }
  }

  onPrevClick = () => {
    if (this.currentSlide === 0) return;
    this.currentSlide--;
    this.handleCarouselClick();
  }

  onNextClick = () => {
    if (this.currentSlide === this.slideCount - 1) return;
    this.currentSlide++;
    this.handleCarouselClick();
  }

  handleCarouselClick = () => {
    this.removeDisabledAttributes(this.prevButton);
    this.removeDisabledAttributes(this.nextButton);

    if (this.currentSlide === this.slideCount - 1) {
      this.addDisabledAttributes(this.nextButton);
    }

    if (this.currentSlide === 0) {
      this.addDisabledAttributes(this.prevButton);
    }

    this.slideCarousel();
  }

  addDisabledAttributes = (element) => {
    if (!element) return;
    element.toggleAttribute('disabled');
    element.toggleAttribute('aria-disabled');
    element.classList.add('MarketingBanner_action-disabled');
  }

  removeDisabledAttributes = (element) => {
    if (!element) return;
    element.removeAttribute('disabled');
    element.removeAttribute('aria-disabled');
    element.classList.remove('MarketingBanner_action-disabled');
  }

  slideCarousel = () => {
    if (!this.wrapper) return;
    const newPosition = this.currentSlide * this.slideWidth * -1;
    this.wrapper.style.transform = `translateX(${newPosition}px)`;
  }
}
